<template>
  <div class="fts-flow-diagram">
    <div :id="diagramId" class="flow-diagram"></div>
    <div class="flow-diagram-fab" v-if="expandable">
      <fts-btn text icon @click="expand">
        <font-awesome-icon :icon="['fas', 'expand-alt']" />
      </fts-btn>
    </div>
    <!-- flow diagram modal -->
    <fts-flow-diagram-modal ref="ftsFlowDiagramModal" />
  </div>
</template>

<script>
import cytoscape from "cytoscape";
import dagre from "cytoscape-dagre";
import flowDiagram from "../library/flowDiagram";

import FTSBtn from "./FTSBtn";
import FTSFlowDiagramModal from "./FTSFlowDiagramModal";

cytoscape.use(dagre);

let dagreLayout = {
  name: "dagre",
  ranker: "network-simplex",
  nodeSep: 100,
  rankSep: 100,
  rankDir: "TB",
  edgeSep: 200
};

export default {
  components: {
    "fts-btn": FTSBtn,
    "fts-flow-diagram-modal": FTSFlowDiagramModal
  },
  props: {
    height: {
      type: String,
      default: "100%"
    },
    expandable: Boolean,
    diagramData: Object
  },
  data: () => ({
    diagramId: null
  }),
  methods: {
    resetLayout() {
      let layout = this.cy.layout(dagreLayout);
      layout.run();
      this.cy.fit();
    },
    expand() {
      this.$refs.ftsFlowDiagramModal.show(this.diagramData);
    },
    redrawDiagram() {
      let vm = this;
      let diagramData = this.diagramData || {};
      let cy = cytoscape({
        container: document.getElementById(vm.diagramId),
        wheelSensitivity: 0.1,
        layout: diagramData.diagram != null ? { name: "preset" } : dagreLayout,
        style: flowDiagram.style,
        elements: {
          nodes: flowDiagram.getNodes(
            diagramData.states || [],
            diagramData.flows || [],
            [],
            diagramData.diagram
          ),
          edges: flowDiagram.getEdges(
            diagramData.activities || [],
            diagramData.states || [],
            diagramData.flows || [],
            [],
            diagramData.diagram
          )
        },
        ready: function() {
          vm.cy = this;
        }
      });
      cy.fit();
    }
  },
  watch: {
    diagramData() {
      this.redrawDiagram();
    }
  },
  mounted() {
    this.redrawDiagram();
  },
  created() {
    this.diagramId = `cy-${this._uid}`;
  }
};
</script>

<style lang="scss" scoped>
.fts-flow-diagram {
  position: relative;
  width: 100%;
  height: 100%;
  .flow-diagram {
    height: 100%;
    width: 100%;
  }
  .flow-diagram-fab {
    position: absolute;
    top: 0;
    right: 0;
    border: 1px solid var(--fts-border);
    border-radius: 10em;
    background-color: var(--fts-card-background);
  }
}
</style>